import type { Agent } from "../types/Agent";

export type FilterByAssignee = Agent | { id: string; name: string };
export const unassignedAgent = { id: "unassigned", name: "Unassigned" };
export const NO_TEAM_FILTER_ID = "no-team";
export const noTeamFilter = { id: NO_TEAM_FILTER_ID, name: "No team" };

export type TeamFilterOption = {
    id: string;
    name: string;
    agentIds: string[];
};

export function teamFilterItems(
    teams: TeamFilterOption[],
    selectedTeamIds: string[],
    countFor: (teamId: string) => number = () => 0,
): { data: { id: string; name: string }; selected: boolean; count: number }[] {
    return [
        {
            data: noTeamFilter,
            selected: selectedTeamIds.includes(NO_TEAM_FILTER_ID),
            count: countFor(NO_TEAM_FILTER_ID),
        },
        ...teams.map((team) => ({
            data: { id: team.id, name: team.name },
            selected: selectedTeamIds.includes(team.id),
            count: countFor(team.id),
        })),
    ];
}

export function countByTeamId(
    teams: TeamFilterOption[],
    assigneeCounts: { id: string; count: number }[],
): Record<string, number> {
    const countByAssignee = new Map(
        assigneeCounts.map((assignee) => [assignee.id, assignee.count]),
    );
    const agentIdsOnATeam = new Set(teams.flatMap((team) => team.agentIds));
    const result: Record<string, number> = {
        [NO_TEAM_FILTER_ID]: assigneeCounts
            .filter(
                (assignee) =>
                    assignee.id === unassignedAgent.id ||
                    !agentIdsOnATeam.has(assignee.id),
            )
            .reduce((sum, assignee) => sum + assignee.count, 0),
    };
    for (const team of teams) {
        result[team.id] = team.agentIds.reduce(
            (sum, agentId) => sum + (countByAssignee.get(agentId) ?? 0),
            0,
        );
    }
    return result;
}

export function getActiveAssigneeSelections(
    assignees: Agent[],
    selectedAgentIds: string[],
) {
    return selectedAgentIds.filter((selected) => {
        const found = assignees
            .filter((it) => !it.disabled)
            .find((it) => it.id === selected);
        return found !== undefined;
    });
}

export function getInactiveAssigneeSelections(
    assignees: Agent[],
    selectedAgentIds: string[],
) {
    return selectedAgentIds.filter((selected) => {
        const found = assignees
            .filter((it) => it.disabled)
            .find((it) => it.id === selected);
        return found !== undefined;
    });
}
